/**
 * @file gravity-breakpoints.ts
 *
 * Gravity CSS-framework breakpoint, spacing, and container values (in pixels),
 * plus their key types. Extracted so layout code and the {@link useResponsive}
 * hook share one source of truth rather than redeclaring magic numbers.
 */

export type GravityBreakPoint =
  | 'mobile_min'
  | 'mobile_max'
  | 'tablet_min'
  | 'tablet_max'
  | 'desktop_min'
  | 'desktop_max'
  | 'mobile_small_min'
  | 'mobile_small_max'
  | 'mobile_large_min'
  | 'mobile_large_max'
  | 'tablet_small_min'
  | 'tablet_small_max'
  | 'tablet_large_min'
  | 'tablet_large_max'
  | 'desktop_small_min'
  | 'desktop_small_max'
  | 'desktop_large_min';

export type GravitySpacing = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export type GravityContainer = 'min' | 'max';

export const BREAKPOINTS: Record<GravityBreakPoint, number> = {
  mobile_min: 360,
  mobile_max: 599,
  tablet_min: 600,
  tablet_max: 1023,
  desktop_min: 1024,
  desktop_max: 1440,
  mobile_small_min: 360,
  mobile_small_max: 413,
  mobile_large_min: 414,
  mobile_large_max: 599,
  tablet_small_min: 600,
  tablet_small_max: 767,
  tablet_large_min: 768,
  tablet_large_max: 1023,
  desktop_small_min: 1024,
  desktop_small_max: 1279,
  desktop_large_min: 1280,
};

export const SPACING: Record<GravitySpacing, number> = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 48,
};

export const CONTAINERS: Record<GravityContainer, number> = {
  min: 360,
  max: 1536,
};
